export default __webpack_public_path__ + "static/media/popup-warning.2a4c4a3a.svg";